import { Link } from "react-router-dom";
import "./home.css"
import BoltIcon from '@mui/icons-material/Bolt';
export default function Home(){
    return(
        <div>
            <section className="home_hero">
                <div className="hero_text">
                    <div className="hero_widget_parent">
                        <div className="hero_widget_icon">
                            <BoltIcon />
                        </div>
                        <div>
                            <div className="hero_widget_text">
                                Don’t just optimize your resume. Optimize your skills
                            </div>
                        </div>
                    </div>
                    <div>
                        <a href="https://www.producthunt.com/products/job-sniper?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-job&#0045;sniper" target="_blank" rel="noreferrer"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1047778&theme=light&t=1765285313231" alt="Job&#0032;Sniper - Finds&#0032;your&#0032;skill&#0032;gaps&#0032;wrt&#0032;your&#0032;target&#0032;job&#0032;and&#0032;helps&#0032;fix&#0032;it | Product Hunt" style={{ width: "250px", height: "54px" }} width="250" height="54" /></a>
                    </div>
                    <div className="hero_main_text">
                        Increase Your Chances of  <span className="hero_main_highlight">Getting Hired </span> by Building the Skills the Job Actually Demands
                    </div>
                    <div className="hero_sub_text">
                        Compare your resume with a job description, identify skill gaps, and get a clear roadmap to close them
                    </div>
                    <div className="hero_cta">
                        <Link to="/analyzer">
                            <div className="hero_gradient_cta">
                                Analyze me!
                            </div>
                        </Link>
                        <a href="#step">
                            <div className="hero_non_gradient_cta">
                                Learn How It Works
                            </div>
                        </a>
                    </div>
                </div>
                <div className="hero_page_1_image_parent">
                    <img className="hero_page_1_image" src="hero_page_1.png" alt="hero_image_page_1" />
                </div>
            </section>
            <section className="hook">
                <div className="hero_other_pages_image_no_animation_parent">
                    <img className="hero_other_pages_image_no_animation" src="skill_gap_image.png" alt="hero_image_page_1" />
                </div>
                <div className="hook_hero_parent">
                    <div className="hook_hero">
                        Identify Your Skill Gaps
                    </div>

                    <div className="hook_hero_2">
                        Get a precise comparison between your resume and the skills required for the role
                    </div>

                    <Link to="/analyzer">
                        <div className="hero_gradient_cta">
                            Show Me What’s Missing
                        </div>
                    </Link>
                </div>
            </section>
            <section className="hook">
                <div className="hook_hero_parent">
                    <div className="hook_hero">
                        Micro Roadmaps Built Around Your Skill Gaps
                    </div>

                    <div className="hook_hero_2">
                        Get focused, step-by-step learning plans that break each missing skill into small, actionable milestones
                    </div>

                    <Link to="/analyzer">
                        <div className="hero_gradient_cta">
                            Build My Roadmap
                        </div>
                    </Link>
                </div>
                <div className="hero_other_pages_image_no_animation_parent">
                    <img className="hero_other_pages_image_no_animation image_page_3" src="roadmap_image.png" alt="hero_image_page_1" />
                </div>
            </section>
            <section className="hook">
                <div className="hero_other_pages_image_no_animation_parent">
                    <img className="hero_other_pages_image_no_animation image_page_4" src="alternate_career_path.png" alt="hero_image_page_1" />
                </div>
                <div className="hook_hero_parent">
                    <div className="hook_hero">
                        Explore Alternative Career Paths
                    </div>

                    <div className="hook_hero_2">
                        After completing your roadmap, explore alternative roles that match your improved skill set
                    </div>

                    <Link to="/analyzer">
                        <div className="hero_gradient_cta">
                            Explore Alternative Roles
                        </div>
                    </Link>
                </div>
            </section>
            <section className="hook">
                <div className="hook_hero_parent">
                    <div className="hook_hero">
                        Targeted Learning Resources
                    </div>

                    <div className="hook_hero_2">
                        Every resource is mapped to a specific competency you need to strengthen
                    </div>

                    <Link to="/analyzer">
                        <div className="hero_gradient_cta">
                            Try it out now!
                        </div>
                    </Link>
                </div>
                <div className="hero_other_pages_image_no_animation_parent">
                    <img className="hero_other_pages_image_no_animation image_page_5" src="learning_resources.png" alt="hero_image_page_1" />
                </div>
            </section>

            <section id="step" className="home_how">
                <div className="home_how_subparent">
                    <div className="hero_main_text bold_text">THREE STEPS ONE POWERFUL SHIFT</div>
                    <div className="hero_sub_text">Three simple steps to identify and bridge your skill gaps</div>
                </div>
                <div className="step_marker">
                    <div className="step_card">
                        <div className="card_head">Step 1</div>
                        <div className="card_hero">Upload Your Resume</div>
                        <div className="card_subtext">
                            Drop in your current resume. We’ll analyze your skills, experience, and strengths automatically
                        </div>
                    </div>
                    <div className="step_card">
                        <div className="card_head">Step 2</div>
                        <div className="card_hero">Upload the Target Job Description</div>
                        <div className="card_subtext">
                            Paste or upload the JD of your dream role. This helps JobSniper map your profile directly to what the company actually wants
                        </div>
                    </div>

                    <div className="step_card">
                        <div className="card_head">Step 3</div>
                        <div className="card_hero">Submit and Generate Your Roadmap</div>
                        <div className="card_subtext">
                            Hit submit. JobSniper instantly builds your custom skill roadmap and action plan
                        </div>
                    </div>
                </div>
            </section>


            <section className="footer">
                <div className="footer_hero_parent">
                    <div className="footer_hero">Your Skill Gap Is Costing You <b>Opportunities</b></div>
                    <div className="footer_subtext">Act now, get your personalized roadmap before you fall further behind   </div>
                </div>
                <Link to="/analyzer">
                    <div className="hero_gradient_cta">Start Your Analysis Now</div>
                </Link>
            </section>

            <section className="addt_links_parent">
                <div className="addt_links_container">
                    <div className="addt_links_hero">
                        Additional Links
                    </div>
                    <ul>
                        <Link to="/privacy-policy">
                            <li>Privacy Policy</li>
                        </Link>
                        <Link to="/terms">
                            <li>Terms of Service</li>
                        </Link>
                    </ul>
                </div>
                <div className="big_text_down">
                    JOB SNIPER
                </div>
            </section>
        </div>
    )
}